import React, { useState } from 'react';
import { connect } from 'react-redux';
import Cropper from 'react-easy-crop';
import { DisplayErrors } from "./Survey.jsx";
import { LoadingIcon } from '../../Common/Loading_Icon';
import Icon from '../../Common/DesignSystem/Icons/Icon';
import Button from '../../Common/DesignSystem/Button.jsx';

import axios from "axios";
import uuid from "uuidv4";

import { uploadS3 } from "../../../Helpers/uploadFile";
import { Trans } from 'react-i18next';
import { generateImage, dataURItoBlob } from '../../../Helpers/cropImage.js';

const ProfilePhotoQuestion = (props) => {

    const [photo, setPhoto] = useState(null);
    const [croppedPhoto, setCroppedPhoto] = useState(null);
    const [croppedPhotoThumbnail, setCroppedPhotoThumbnail] = useState(null);
    const [crop, setCrop] = useState({x: 0, y: 0});
    const [cropChanged, setCropChanged] = useState(false);
    const [croppedArea, setCroppedArea] = useState(null);
    const [zoom, setZoom] = useState(1);
    const [error, setError] = useState('');
    const [loadingImg, setLoadingImg] = useState(false);
    const [answers, setAnswers] = useState([]);

    function onSelectFile (event) {
      if (event.target.files && event.target.files.length > 0) {
        setError('');
        setLoadingImg(true);
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.addEventListener("load", () => {
          setPhoto(reader.result);
          setLoadingImg(false);
        });
      }
    };

    function onCropComplete(croppedArea, croppedAreaPixels) {
      setCroppedArea(croppedAreaPixels);
    }

    function localValidation(e, props, skip) {
      if (skip) {
        setError('');
        let respo = {'question_id': props.question.Id, "answer": ''};
        props.handleResponse(e, props, respo);
      } else {
        setError('');
        uploadImage('fileupload').then((res)=> {
          if (res && res.url) {
            submitPhoto(res.url).then(() => {
              props.handleResponse(e, props, res.answer);
            });
          } else {
            setError('Please select a photo or press the "Skip for now" button.');
            // props.handleResponse(e, props, null);
          }
        })
      }
    }

    function triggerFile(id) {
        $('#' + id).click();
    }

    async function submitPhoto(photo) {    
        return axios({
          method: "post",
          url: "ajax/updateimage/" + props.userSession.user.profile_id,
          data: {
            photo: photo,
          },
          config: { headers: { "Content-Type": "multipart/form-data" } },
        })
          .then(function(response) {
            showStatusMsg(response?.data.message, "success");
            setLoadingImg(false);
          })
          .catch(function(error) {
            //handle error
            if (error.response?.status == 401) {
              showStatusMsg(error.response?.data.error);
            } else if (error.response?.status == 422) {
              var error_message = "";
    
              $.each(error.response?.data.errors, function(index, element) {
                error_message += element + "<br />";
              });
    
              showStatusMsg(error_message);
            } else {
              showStatusMsg("Requested information not found");
            }
    
            setLoadingImg(false);
          });
      }

    async function uploadImage(id) {
      var filename = document
        .getElementById(id)
        .value?.split(/(\\|\/)/g)
        .pop();
      if (filename) {
        var original_filename = filename?.split(".")[0];
        var extension = filename?.split(".")[1].toLowerCase();
        var unique_id = uuid();
    
        setLoadingImg(true);
        var dataUrl = croppedPhoto;
        var dataUrl_thumb = croppedPhotoThumbnail;
        var blobData = dataURItoBlob(dataUrl);
        var blobData_thumb = dataURItoBlob(dataUrl_thumb);
    
        const uploadedThumb = new Promise((resolve, reject) => {
          uploadS3(blobData_thumb, 'thumbnail_' + original_filename, extension, '/profile-images/thumbnails', unique_id, (res)=> {
            let url = res;
            resolve();
            setAnswers({'question_id': props.question.Id, 'answer': url});
          },(err)=> {
            reject();
          });
        });

        const uploadedFull = new Promise((resolve, reject) => {
          uploadS3(blobData, original_filename, extension, '/profile-images', unique_id, (res)=> {
            let url = res;
            setAnswers({'question_id': props.question.Id, 'answer': url});
            setLoadingImg(false);
            resolve({url, answer: {'question_id': props.question.Id, 'answer': url}});
            
          }, (err)=> {
            reject();
          })
        })
        return Promise.all([uploadedThumb, uploadedFull]).then((values)=> {
          return values[1];
        })
      }
    }
    
    function checkIfJson(json) {
        try {
            JSON.parse(json);
        } catch (e) {
            return false;
        }
        return true;
    }

    return (
        <div className="registration-main upload-question" style={{display: 'flex', flexDirection: 'column'}}>
          <div className={"survey-questions-container question-" + (props.page)}>
            <h3 className = "question-title">{ props.question.Text }</h3>
            <div className="survey-question-description">{ checkIfJson(props.question.Help_Text) && "description" in (JSON.parse(props.question.Help_Text)) ?
                (JSON.parse(props.question.Help_Text)).description : "" }
            </div>
            <div className="body"></div>
            <div className="loading-wrapper" id='file-upload' alt='Loading' style={{display: 'none'}}>
                <div className="lds-ring bkg-border-primary"><div></div><div></div><div></div><div></div></div>
            </div>
            <div className="survey-profile-img-container">
                <div className="survey-profile-img-box">
                    <div className="survey-profile-img-inner-box">
                      <>
                        {loadingImg ? 
                          <div style={{position: 'absolute', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: 3, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', color: 'white', fontWeight: 'bold'}}>
                            Loading...
                          </div>
                          : null
                        }
                        {photo ?
                          <Cropper
                            classes="survey-profile-img"
                            objectFit="vertical-cover"
                            image={photo}
                            crop={crop}
                            zoom={zoom}
                            showGrid={cropChanged}
                            aspect={1}
                            onCropChange={(e) => {
                              setCrop(e);
							  setCropChanged(true);
                            }}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                          />
                          // <div>
                          //   <img className="survey-profile-img" src={"https://s3.ca-central-1.amazonaws.com/digitalvms/profile-images/" + this.state.photo} />
                          // </div>
                        : !loadingImg ? 
                        <div className="survey-profile-img-upload-icon" onClick={() => triggerFile('fileupload')}>
                            <Icon name="Upload" size={24}/>
                        </div> : null}
                        <input id="files" type="file" name="files[]" style={{display: 'none'}} data-form-data='{"script": "true"}' />
                      </>
                    </div>
                    {photo && cropChanged ? 
                      <div style={{marginBottom: 12}}>
                        <Button label="Save" primary onClick={()=> {
                          setLoadingImg(true);
                          generateImage(photo, croppedArea, true)
                            .then((res)=> {
                              setCroppedPhotoThumbnail(res.toDataURL());
                            })
                          generateImage(photo, croppedArea)
                            .then((res)=> {
                              setCroppedPhoto(res.toDataURL());
                              setLoadingImg(false);
                              setTimeout(()=> {
                                setCropChanged(false);
                              }, 300)
                            })
                          }}/>
                      </div>
                    : !photo ? 
                      <div style={{marginBottom: 12}}>
                        <Button label="Upload your photo" secondary onClick={()=> {
                            triggerFile('fileupload')
                          }}/>
                      </div>
                    : !cropChanged ? 
                    <div style={{display: 'flex', marginBottom: 12, flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'space-evenly'}}>
                      <Button label="Upload new" medium secondary style={{width: 112}} onClick={()=> {
                          setPhoto(null);
                          setCrop({x: 0, y: 0});
                          setCroppedPhoto(null);
                          setZoom(1);
                          setCroppedArea(null);
                          triggerFile('fileupload')
                        }}/>
                      <Button label="Remove photo" medium secondary style={{width: 112}} onClick={()=> {
                          setPhoto(null);
                          setCrop({x: 0, y: 0});
                          setCroppedPhoto(null);
                          setZoom(1);
                          setCroppedArea(null);
                        }}/>
                    </div>
                  : null}
                </div>
            </div>
            <div>
                <span id="loading-icon" style={{display: 'none'}}><LoadingIcon /></span>
                <input type="file" id="fileupload" onChange={onSelectFile} style={{display: 'none'}} accept=".png,.jpg,.jpeg" /> 
            </div>
            <input type='hidden' name='required' id='required' value={ (props.question.Validation).includes("required") ? true : false }/>
            <DisplayErrors errors={props.errors.concat([error])} />
        </div>
        <div className="survey-profile-img-bottom-button-container">
            {props.question.question_orders.length == 0 || props.question.question_orders[0].Question_Order != 1 ? 
                <Button label="Back" tertiary leading_ic="ArrowLeft" onClick={(e) => props.loadSurvey(e, props, 'previous')}/>
            : null}

            <div style={{display: 'flex', alignItems: 'center'}}>
                {!(props.question.Validation).includes('required') ? 
                    <span className="grey" style={{cursor: "pointer", marginRight: 16}} onClick={(e) => localValidation(e, props, true)}><Trans>Skip for now</Trans></span>
                : null }
                <Button label="Next" primary trailing_ic="ArrowRight" disabled={cropChanged} onClick={(e) => localValidation(e, props, false)}/>
            </div>
        </div>
    </div>
    );
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(ProfilePhotoQuestion);